module.exports = __webpack_public_path__ + "static/img/projectDetail_2.1fd6e90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainPage/projectDetail_2.jpg
// module id = RA4a
// module chunks = 0